import {
  Container,
  LoadingOverlay,
  Group,
  Stack,
  Text,
  Flex,
  Box,
  Image,
  Button,
  MultiSelect,
  Center,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Login, LoginUsers } from "../../components/Authentication/Login/Login";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/ReduxStore";
import { loginUser } from "../../features/auth/loginSlice";
import { Mixpanel } from "../../utilities/Mixpanel/MixpanelHelper";
import {
  GetUser,
  GetValueFromLocalStorage,
  LocalStorageKey,
  RemoveValueFromLocalStorage,
} from "../../utilities/LocalstorageUtility";
import { useMediaQuery } from "@mantine/hooks";
import { TeacherPageEvents } from "../../utilities/Mixpanel/AnalyticeEventTeacherApp";
import { convertToHyphenSeparated } from "../../utilities/HelperFunctions";
import { WebAppEvents } from "../../utilities/Mixpanel/AnalyticeEventWebApp";
import { LoginPageFooter } from "../../components/LoginPageFooter";
import { googleLoginUser } from "../../features/auth/googleLoginSlice";
import { ShowOnboarding } from "../../features/user/userSlice";

interface AuthenticationPageProps {
  onLoginSuccess: () => void;
  isTeacherLogin?: boolean;
  defaultDetails?: LoginFormDetails;
}

export function AuthenticationPage(props: AuthenticationPageProps) {
  const [instituteId, setInstituteId] = useState<string>();
  const [userId, setUserId] = useState<string>();
  const [showOnboarding, setShowOnboarding] = useState<boolean>(false);
  enum AuthPageType {
    Login,
    Signup,
    ForgotPassword,
  }
  const [shownAuthPageType, setShownAuthPageType] = useState(
    AuthPageType.Login
  );

  useEffect(() => {
    Mixpanel.track(WebAppEvents.VIGNAM_APP_LOGIN_PAGE_ACCESSED);
    if (
      props.defaultDetails &&
      props.defaultDetails.email != null &&
      props.defaultDetails.email != ""
    ) {
      onLoginClick(props.defaultDetails);
    }
  }, []);
  
  useEffect(() => {
    RemoveValueFromLocalStorage(LocalStorageKey.User);
    RemoveValueFromLocalStorage(LocalStorageKey.Token);
    RemoveValueFromLocalStorage(LocalStorageKey.UserType);
  }, []);
  const [loadingData, setLoadingData] = useState<boolean>(false);
  const [iserror, setIsError] = useState<boolean>(false);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const isMd = useMediaQuery(`(max-width:770px)`);
  const instituteDetails = useSelector<RootState, InstituteDetails | null>(
    (state) => state.instituteDetailsSlice.instituteDetails
  );

  function onLoginClick(details: LoginFormDetails) {
    setLoadingData(true);
    (details.password === ""
      ? dispatch(googleLoginUser({ email: details.email, name: details.name! }))
      : dispatch(
          loginUser({ email: details.email, password: details.password })
        )
    )
      .unwrap()
      .then((data) => {
        setLoadingData(false);
        setUserId(data.user._id);
        setInstituteId(data.user.instituteId._id);
        ShowOnboarding(data.user._id)
          .then((x: any) => {
            if (x.showOnboarding) {
              setShowOnboarding(x.showOnboarding);
              return;
            }
            Mixpanel.track(TeacherPageEvents.USER_SIGN_IN_SUCCESS, {
              email: details.email,
            });
            const user = GetUser();
            const userType = GetValueFromLocalStorage(LocalStorageKey.UserType);
            navigate(
              `/${convertToHyphenSeparated(user.instituteName)}/${
                user.instituteId
              }/teach1/dashboard`
            );
            props.onLoginSuccess()
          })
          .catch((e) => {
            console.error("Onboarding error:", e);
          });
      })
      .catch((error) => {
        Mixpanel.track(WebAppEvents.USER_SIGN_IN_FAILED, {
          error: error.message,
        });
        setIsError(true);
        setLoadingData(false);
      });
  }
  

  function showView(type: AuthPageType) {
    switch (type) {
      case AuthPageType.Login:
        setShownAuthPageType(AuthPageType.Login);
        break;
      case AuthPageType.Signup:
        setShownAuthPageType(AuthPageType.Signup);
        break;
      case AuthPageType.ForgotPassword:
        setShownAuthPageType(AuthPageType.ForgotPassword);
        break;
    }
  }

  return (
    <Stack>
      <Flex
        w={"100%"}
        h={"100vh"}
        bg={"#F5F5F5"}
        direction={isMd ? "column" : "row"}
      >
        {isMd ? (
          <>
            <Flex w={"100%"} align={"center"} justify={"end"}>
              <Stack w={"100%"} sx={{ position: "relative", left: 0, top: 0 }}>
                <Image
                  src={require("../../assets/loginImgMobile.png")}
                  style={{ width: "100%" }}
                />
              </Stack>
              <Box w={"100%"} style={{ position: "absolute" }}>
                <Image
                  src={require("../../assets/loginImg.png")}
                  style={{ width: "100%" }}
                />
              </Box>
            </Flex>
          </>
        ) : (
          <Stack style={{ width: "55%", height: "100%" }}>
            <Stack m={24}>
              <Text fz={36} fw={800} color="#3D418F">
                Welcome back!
              </Text>
              <Text color="#3D418F" mt={-16} fw={600}>
                Where learning meets Innovation
              </Text>
            </Stack>

            <Flex w={"120%"} h={"100%"} align={"center"} justify={"end"}>
              <Flex w={"100%"}>
                <Image
                  src={require("../../assets/loginImg.png")}
                  style={{ width: "100%" }}
                />
              </Flex>
            </Flex>
          </Stack>
        )}
        <Container
          style={{
            width: isMd ? "100%" : "45%",
            padding: 0,
            margin: 0,
            background: "white",
          }}
        >
          {shownAuthPageType === AuthPageType.Login && (
            <Center h={"100%"}>
              {
                <Login
                  OnForgotPasswordClick={() =>
                    showView(AuthPageType.ForgotPassword)
                  }
                  showOnboarding={showOnboarding}
                  instituteId={instituteId!!}
                  userId={userId!!}
                  OnLoginClick={onLoginClick}
                  OnSignupClick={() => showView(AuthPageType.Signup)}
                  iserror={iserror}
                  setisError={setIsError}
                />
              }
            </Center>
          )}
          <LoadingOverlay visible={loadingData}></LoadingOverlay>
        </Container>
      </Flex>
      {isMd && <LoginPageFooter instituteName={instituteDetails?.name ?? ""} />}
    </Stack>
  );
}
